import Services from "api/ProjectApiConsumer";
import { message } from "antd";
import { BASE_URL } from "constants/index";

// === Função genérica de SSE ===
export const startSSE = (id, eventSourcesRef, action) => {
  if (eventSourcesRef.current[id]) return;

  const es = new EventSource(`${BASE_URL}/api/users/evo/${id}/sync-status`);
  eventSourcesRef.current[id] = es;

  es.onmessage = (event) => {
    const update = JSON.parse(event.data);

    if (update.status === "DONE") {
      message.success(`A sincronização com o evo foi finalizada!`);
      es.close();
      delete eventSourcesRef.current[id];
      action?.()
    }
    
  };

  es.onerror = () => {
    message.warning(`Conexão EVO perdida. Tentando reconectar...`);
    es.close();
    delete eventSourcesRef.current[id];
    setTimeout(() => startSSE(id, eventSourcesRef, action ), 10000); // reconecta após 10s
  };
};


export function syncEvo(param) {
  return Services.evoService.syncEvo(undefined, param);
}

